import rightImg from "images/about-hero-right.png";
import { FC } from "react";
import { Helmet } from "react-helmet";
import SectionAbout from "./SectionAbout";
import { useData } from "data/data-provider";
import BgGlassmorphism from "designs/DesignA/components/BgGlassmorphism/BgGlassmorphism";

export interface PageAboutProps {
  className?: string;
}

const PageAbout: FC<PageAboutProps> = ({ className = "" }) => {
  const { aboutUs } = useData();
  return (
    <div
      className={`nc-PageAbout overflow-hidden relative ${className}`}
      data-nc-id="PageAbout"
    >
      <Helmet>
        <title>About</title>
      </Helmet>

      <h1 className="text-7xl font-semibold text-text-color mt-6 w-full text-center">
        About Us
      </h1>

      {/* ======== BG GLASS ======== */}
      <BgGlassmorphism />

      <div className="container py-12 lg:py-20 space-y-16 lg:space-y-28">
        {aboutUs && <SectionAbout aboutUs={aboutUs} />}
      </div>
    </div>
  );
};

export default PageAbout;
